import { Link, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";

const api_url = process.env.REACT_APP_API_URL;

function Login() {
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  // ✅ Redirect to dashboard if already logged in
  useEffect(() => {
    const authKey = sessionStorage.getItem("auth_key");
    const expiry = sessionStorage.getItem("session_expiry");

    if (authKey && expiry && Date.now() < parseInt(expiry)) {
      navigate("/portal/dashboard");
    }
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    try {
      const response = await axios.post(`${api_url}/login.php`, form);
      const data = response.data;

      if (data.success) {
        // ✅ Save auth session
        sessionStorage.setItem("auth_key", data.auth_key);
        sessionStorage.setItem("username", data.username);
        sessionStorage.setItem("user_id", data.user_id);
        sessionStorage.setItem("user_level", data.user_level);

        // ✅ Set session expiry (30 minutes)
        const expiryTime = Date.now() + 30 * 60 * 1000;
        sessionStorage.setItem("session_expiry", expiryTime);

        // Redirect to dashboard
        window.location.href = "/portal/dashboard";
      } else {
        setErrorMsg(data.message || "Login failed.");
      }
    } catch (err) {
      console.error(err);
      setErrorMsg("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container-fluid bg-primary py-5 mb-5 page-header">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h1 className="display-3 text-white animated slideInDown">Login</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item"><Link className="text-white" to="/">Home</Link></li>
                  <li className="breadcrumb-item text-white active" aria-current="page">Login</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="row justify-content-center">
            <div className="card col-md-5 login-card">
              <div className="card-body">
                <h3 className="text-center">Login</h3>
                <form onSubmit={handleSubmit}>
                  <div className="row justify-content-center g-3">
                    <div className="form-group">
                      <label>Your Username</label>
                      <input
                        type="text"
                        className="form-control"
                        name="username"
                        value={form.username}
                        onChange={handleChange}
                        placeholder="Your Username"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Your Password</label>
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        placeholder="Your Password"
                        required
                      />
                    </div>

                    {errorMsg && (
                      <div className="text-danger text-center">
                        <small>{errorMsg}</small>
                      </div>
                    )}

                    <div className="col-md-6 d-flex justify-content-center">
                      <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? "Logging in..." : "Login"}
                      </button>
                    </div>

                    <div className="d-flex justify-content-between">
                      <Link to="/forgetPassword" className="forgot text-warning">
                        <b>Forgot Password?</b>
                      </Link>
                      <Link to="/membership_register" className="forgot text-success">
                        <b>Registration Page</b>
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
